// src/components/terms/TermsAndConditions.styles.js

import theme from './../../theme';

const TermsStyles = {
  container: {
    padding: '80px 20px',
    backgroundColor: theme.colors.extraLightGray,
    textAlign: 'center',
    maxWidth: '950px',
    margin: '0 auto',
    borderRadius: '16px',
    boxShadow: '0 6px 24px rgba(20,30,80,0.07)',
  },
  title: {
    fontFamily: theme.fonts.secondary,
    fontWeight: 800,
    fontSize: '2.8rem',
    color: theme.colors.darkGray,
    marginBottom: '16px',
    '@media (max-width: 768px)': {
      fontSize: '2rem',
    },
  },
  subtitle: {
    fontFamily: theme.fonts.secondary,
    fontSize: '1.2rem',
    color: theme.colors.mediumGray,
    marginBottom: '40px',
  },
  section: {
    textAlign: 'left',
    marginBottom: '44px',
    padding: '0 4px',
    borderRadius: '12px',
    background: '#fff',
    boxShadow: '0 2px 8px rgba(50,60,80,0.02)',
  },
  sectionTitle: {
    fontFamily: theme.fonts.secondary,
    fontWeight: 700,
    fontSize: '1.5rem',
    color: theme.colors.darkGray,
    marginBottom: '12px',
    marginTop: '0',
    paddingTop: '24px',
    '@media (max-width: 600px)': {
      fontSize: '1.2rem',
    },
  },
  text: {
    fontFamily: theme.fonts.secondary,
    color: theme.colors.mediumGray,
    fontSize: '1rem',
    lineHeight: '1.75',
    marginBottom: '8px',
    '& ul': {
      paddingLeft: '22px',
      marginBottom: '8px',
    },
    '& li': {
      marginBottom: '8px',
    },
    '& a': {
      color: theme.colors.primary,
      textDecoration: 'underline',
      transition: 'color 0.2s',
      '&:hover': {
        color: theme.colors.primaryDark,
      },
    },
    '@media (max-width: 600px)': {
      fontSize: '0.96rem',
    },
  },
};

export default TermsStyles;
